import {
  PURCHASE_ORDERS_INDEX_REQUESTED,
  PURCHASE_ORDERS_INDEX_SUCCESS,
  PURCHASE_ORDERS_INDEX_FAILURE,
  PURCHASE_ORDER_FIND_REQUESTED,
  PURCHASE_ORDER_FIND_SUCCESS,
  PURCHASE_ORDER_FIND_FAILURE,

  PURCHASE_ORDERS_CREATE_REQUESTED,
  PURCHASE_ORDERS_CREATE_SUCCESS,
  PURCHASE_ORDERS_CREATE_FAILURE,

  PURCHASE_ORDERS_UPDATE_REQUESTED,
  PURCHASE_ORDERS_UPDATE_SUCCESS,
  PURCHASE_ORDERS_UPDATE_FAILURE,

  PURCHASE_ORDER_MARK_PAID_REQUESTED,
  PURCHASE_ORDER_MARK_PAID_SUCCESS,
  PURCHASE_ORDER_MARK_PAID_FAILURE,
  PURCHASE_ORDER_MARK_CLOSED_REQUESTED,
  PURCHASE_ORDER_MARK_CLOSED_SUCCESS,
  PURCHASE_ORDER_MARK_CLOSED_FAILURE,
  PURCHASE_ORDER_MARK_ISSUED_REQUESTED,
  PURCHASE_ORDER_MARK_ISSUED_SUCCESS,
  PURCHASE_ORDER_MARK_ISSUED_FAILURE,
  PURCHASE_ORDER_MARK_FULFILLED_REQUESTED,
  PURCHASE_ORDER_MARK_FULFILLED_SUCCESS,
  PURCHASE_ORDER_MARK_FULFILLED_FAILURE,
  PURCHASE_ORDER_MARK_REJECTED_REQUESTED,
  PURCHASE_ORDER_MARK_REJECTED_SUCCESS,
  PURCHASE_ORDER_MARK_REJECTED_FAILURE,

  PURCHASE_ORDER_UPDATE_SHIPMENTS_REQUESTED,
  PURCHASE_ORDER_UPDATE_SHIPMENTS_SUCCESS,
  PURCHASE_ORDER_UPDATE_SHIPMENTS_FAILURE,

  PURCHASE_ORDER_CHECK_ITEM_EXISTENCE_REQUESTED,
  PURCHASE_ORDER_CHECK_ITEM_EXISTENCE_SUCCESS,
  PURCHASE_ORDER_CHECK_ITEM_EXISTENCE_FAILURE,


  PURCHASE_ORDER_DOWNLOAD_REQUESTED,
  PURCHASE_ORDER_DOWNLOAD_SUCCESS,
  PURCHASE_ORDER_DOWNLOAD_FAILURE,

  RESET_PURCHASE_ORDER_STATE,
  RESET_NEW_PO,
} from '../types';

const INITIAL_STATE = {
  isFetching: false,
  isCreating: false,
  status: 'waiting',
  purchaseOrders: [],
  activePurchaseOrder: null,
  newPurchaseOrder: null,
  updatingPaidList: [],
  updatingIssuedList: [],
  updatingClosedList: [],
  updatingRejectedList: [],
  purchaseOrdersSearchStack: [''],
  reverseOrder: true,
  sortIndex: null,
  lastPage: true,
  downloadUrl: null,
  unverifiedLineItems: [],
  confirmedLineItems: [],
  missingLineItems: [],
  errors: null
};

const purchaseOrders = (state = INITIAL_STATE, action) => {
  const newState = { ...state };
  let toUpdate = null;

  switch(action.type) {
    case PURCHASE_ORDERS_INDEX_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        purchaseOrders: [],
        status: 'requesting',
        updatingPaidList: [],
        updatingClosedList: [],
        updatingIssuedList: [],
        updatingRejectedList: [],
        errors: null,
      });

    case PURCHASE_ORDERS_INDEX_SUCCESS:
      newState.isFetching = false;
      newState.status = 'success';
      newState.purchaseOrders = action.payload.purchase_orders;
      newState.errors = null;
      newState.lastPage = action.payload.last_page;
      newState.sortIndex = action.payload.sort_index;
      newState.reverseOrder = action.payload.reverse_order;

      if(action.payload.continuation_token !== null) {
        newState.purchaseOrdersSearchStack[action.page] = action.payload.continuation_token;
      }

      return newState;

    case PURCHASE_ORDERS_INDEX_FAILURE:
      return Object.assign({}, null, {
        isFetching: false,
        status: 'waiting',
        purchaseOrders: [],
        purchaseOrdersSearchStack: [''],
        reverseOrder: true,
        sortIndex: null,
        lastPage: true,
        downloadUrl: null,
        newPurchaseOrder: null,
        errors: 'Error loading purchase orders'
      });

    case PURCHASE_ORDER_FIND_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        status: 'requesting',
        activePurchaseOrder: null,
        errors: null
      });

    case PURCHASE_ORDER_FIND_SUCCESS:
      let newUnverifiedLineItems = [];

      action.payload.purchase_order_lines.purchase_order_lines.forEach((product) => {
        newUnverifiedLineItems.push(product.id);
      });

      newState.isFetching = false;
      newState.status = 'success';
      newState.activePurchaseOrder = action.payload;
      newState.unverifiedLineItems = newUnverifiedLineItems;
      newState.confirmedLineItems = [];
      newState.missingLineItems = [];

      return newState;

    case PURCHASE_ORDER_FIND_FAILURE:
      return Object.assign({}, state, {
        isFetching: false,
        status: 'waiting',
        errors: 'error here'
      });

    case PURCHASE_ORDERS_CREATE_REQUESTED:
      newState.newPurchaseOrder = null;
      newState.isCreating = true;
      return newState;

    case PURCHASE_ORDERS_CREATE_SUCCESS:
      newState.newPurchaseOrder = action.purchaseOrder;
      newState.isCreating = false;
      return newState;

    case PURCHASE_ORDERS_CREATE_FAILURE:
      newState.isCreating = false;
      newState.errors = 'Could not create order';
      return newState;


    case PURCHASE_ORDERS_UPDATE_REQUESTED:
      newState.newPurchaseOrder = null;
      newState.isCreating = true;
      return newState;

    case PURCHASE_ORDERS_UPDATE_SUCCESS:
      newState.newPurchaseOrder = action.purchaseOrder;
      newState.isCreating = false;
      return newState;

    case PURCHASE_ORDERS_UPDATE_FAILURE:
      newState.isCreating = false;
      newState.errors = 'Could not update order';
      return newState;

    case PURCHASE_ORDER_MARK_FULFILLED_REQUESTED:
    case PURCHASE_ORDER_MARK_ISSUED_REQUESTED:
      newState.updatingIssuedList.push(action.purchaseOrderId);
      return newState;

    case PURCHASE_ORDER_MARK_ISSUED_SUCCESS:
      toUpdate = newState.updatingIssuedList.findIndex(id => id === action.purchaseOrderId);
      delete newState.updatingIssuedList[toUpdate];

      toUpdate = newState.purchaseOrders.findIndex(purchaseOrder => purchaseOrder?.id === action.purchaseOrderId);
      newState.purchaseOrders[toUpdate].status = 'issued';

      return newState;

    case PURCHASE_ORDER_MARK_FULFILLED_SUCCESS:
      toUpdate = newState.updatingIssuedList.findIndex(id => id === action.purchaseOrderId);
      delete newState.updatingIssuedList[toUpdate];

      toUpdate = newState.purchaseOrders.findIndex(purchaseOrder => purchaseOrder?.id === action.purchaseOrderId);
      newState.purchaseOrders[toUpdate].status = 'fulfilled';

      return newState;

    case PURCHASE_ORDER_MARK_FULFILLED_FAILURE:
    case PURCHASE_ORDER_MARK_ISSUED_FAILURE:
      toUpdate = newState.updatingIssuedList.findIndex(id => id === action.purchaseOrderId);
      delete newState.updatingIssuedList[toUpdate];
      return newState;


    case PURCHASE_ORDER_MARK_PAID_REQUESTED:
      newState.updatingPaidList.push(action.purchaseOrderId);
      return newState;

    case PURCHASE_ORDER_MARK_PAID_SUCCESS:
      toUpdate = newState.updatingPaidList.findIndex(id => id === action.purchaseOrderId);
      delete newState.updatingPaidList[toUpdate];

      toUpdate = newState.purchaseOrders.findIndex(purchaseOrder => purchaseOrder?.id === action.purchaseOrderId);
      newState.purchaseOrders[toUpdate].payment_status = 'paid';

      return newState;

    case PURCHASE_ORDER_MARK_PAID_FAILURE:
      toUpdate = newState.updatingPaidList.findIndex(id => id === action.purchaseOrderId);
      delete newState.updatingPaidList[toUpdate];
      return newState;


    case PURCHASE_ORDER_MARK_CLOSED_REQUESTED:
      newState.updatingClosedList.push(action.purchaseOrderId);
      return newState;

    case PURCHASE_ORDER_MARK_CLOSED_SUCCESS:
      toUpdate = newState.updatingClosedList.findIndex(id => id === action.purchaseOrderId);
      delete newState.updatingClosedList[toUpdate];

      toUpdate = newState.purchaseOrders.findIndex(purchaseOrder => purchaseOrder?.id === action.purchaseOrderId);
      delete newState.purchaseOrders[toUpdate];

      return newState;

    case PURCHASE_ORDER_MARK_CLOSED_FAILURE:
      toUpdate = newState.updatingClosedList.findIndex(id => id === action.purchaseOrderId);
      delete newState.updatingClosedList[toUpdate];
      return newState;


    case PURCHASE_ORDER_MARK_REJECTED_REQUESTED:
      newState.updatingRejectedList.push(action.purchaseOrderId);
      return newState;

    case PURCHASE_ORDER_MARK_REJECTED_SUCCESS:
      toUpdate = newState.updatingRejectedList.findIndex(id => id === action.purchaseOrderId);
      delete newState.updatingRejectedList[toUpdate];

      toUpdate = newState.purchaseOrders.findIndex(purchaseOrder => purchaseOrder?.id === action.purchaseOrderId);
      delete newState.purchaseOrders[toUpdate];

      return newState;

    case PURCHASE_ORDER_MARK_REJECTED_FAILURE:
      toUpdate = newState.updatingRejectedList.findIndex(id => id === action.purchaseOrderId);
      delete newState.updatingRejectedList[toUpdate];
      return newState;

    case PURCHASE_ORDER_CHECK_ITEM_EXISTENCE_SUCCESS:
      toUpdate = newState.unverifiedLineItems.findIndex(id => id === action.itemResult.id);
      delete newState.unverifiedLineItems[toUpdate];
      if(action.itemResult.result === 'success') {
        newState.confirmedLineItems.push(action.itemResult.id);
      } else {
        newState.missingLineItems.push(action.itemResult.id);
      }
      return newState;

    case PURCHASE_ORDER_DOWNLOAD_REQUESTED:
      newState.downloadUrl = null;
      return newState;

    case PURCHASE_ORDER_DOWNLOAD_SUCCESS:
      newState.downloadUrl = action.downloadUrl;
      return newState;

    case PURCHASE_ORDER_DOWNLOAD_FAILURE:

      return newState;


    case PURCHASE_ORDER_UPDATE_SHIPMENTS_REQUESTED:
      newState.status = 'updating';
      return newState;

    case PURCHASE_ORDER_UPDATE_SHIPMENTS_SUCCESS:
      newState.status = 'success';
      newState.activePurchaseOrder.shipments = action.shipments;
      return newState;

    case PURCHASE_ORDER_UPDATE_SHIPMENTS_FAILURE:
      newState.status = 'failure';
      return newState;

    case RESET_PURCHASE_ORDER_STATE:
      newState.isFetching = false;
      newState.isCreating = false;
      newState.status = 'waiting';
      newState.purchaseOrders = [];
      newState.activePurchaseOrder = null;
      newState.newPurchaseOrder = null;
      newState.updatingIssuedList = [];
      newState.updatingPaidList = [];
      newState.updatingClosedList = [];
      newState.updatingRejectedList = [];
      newState.purchaseOrdersSearchStack = [''];
      newState.lastPage = true;
      newState.downloadUrl = null;
      newState.errors = null;
      return newState;

    case RESET_NEW_PO:
      newState.newPurchaseOrder = null;
      return newState;

    default:
      return state;
  }
}

export default purchaseOrders;